import { IAuthState } from './interface';

export function AuthStateFactory(data?: Partial<IAuthState>): IAuthState {
    return {
        user: data?.user,
        authToken: data?.authToken,
    };
}
